import {Component, Input, OnDestroy, OnInit, signal, WritableSignal} from '@angular/core';
import { TipoTramiteService } from '../../../services/tipoTramite.service';
import {IGetTramitesBusqueda, IIdCompuestoVersion} from '../../../shared/interfaces/configuracion';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import {AuthService, IColumns, LocalService, PaginationParams, Page, AlertService, AlertIcon} from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AuthenticationManagerService } from '../../../services/authentication-manager.service';
import {firstValueFrom, forkJoin, Subscription, timeout} from 'rxjs';
import { MessageService } from 'primeng/api';
import {ItemTramiteResultadoComponent} from "../item-tramite-resultado/item-tramite-resultado.component";
import {DataViewModule, DataViewPageEvent} from "primeng/dataview";
import {VwSecDependencia} from "../../../../../../administracion/src/app/shared/interfaces/database/seguridad";
import { TramRegistroSolicitudService } from '../../../services/tramiteRegistroSolicitud.service';
import {ResponseAlert} from "../../../../../../lib-base/src/lib/shared";
import {IValidarTramiteActivo} from "../../../shared/interfaces/tramite";



@Component({
  selector: 'app-resultados-busqueda',
  standalone: true,
  imports: [CommonModule, TranslateModule,
    TableModule, ButtonModule, ItemTramiteResultadoComponent, DataViewModule
  ],
  templateUrl: './resultados-busqueda.component.html',
  styleUrl: './resultados-busqueda.component.scss'
})
export class ResultadosBusquedaComponent implements OnInit, OnDestroy {

  @Input({alias: 'text'}) text!: string | undefined;
  @Input('dependencias') dependencia!: VwSecDependencia[];

  protected _typeContent: 'card' | 'list' = "card";

  @Input ({required: true})
  set typeContent(value: 'card' | 'list') {
    this._typeContent = value;
    this.styleCustomClass =  (this._typeContent === 'list') ?
     'container-list' :'';

  }

  styleCustomClass: string | undefined;

  results: IGetTramitesBusqueda[] = [];
  totalRecords:WritableSignal <number> = signal(0);
  isLoading:boolean = false;
  columns !: IColumns[];
  rows:number;
  private _loginSubscription !: Subscription;
  private _menuCloseSubscription !: Subscription;
  page:number;
  first:number;

  protected _translations: any = {};

  constructor(private _tt: TipoTramiteService, private _ar: ActivatedRoute, private _router: Router, private _ls: LocalService,
    private _ams: AuthenticationManagerService, private _as: AuthService, private readonly _trs: TramRegistroSolicitudService,
              private _translate: TranslateService, private _ms: MessageService, private alertService:AlertService
  ) {
    this.text = this._ar.snapshot.params['text'];
    this.rows = 4;
    this.page = 0;
    this.first = 0;

  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  ngOnInit() {
    this.translate();
    if(this.text)
      this.getTramitesBusqueda(this.text,);
  }

  private async translate(): Promise<void>{
    this._translations = await firstValueFrom(forkJoin({
      warnSummary: this._translate.get('form.msg.warn-summary'),
      necesitaPersonaJuridica: this._translate.get('components.app-resultados-busqueda.necesita-persona-juridica'),
      necesitaPersonaJuridicaOpcional: this._translate.get('components.app-resultados-busqueda.necesita-persona-juridica-opcional'),
      personaJuridica: this._translate.get('components.app-resultados-busqueda.persona-juridica'),
      personaNatural: this._translate.get('components.app-resultados-busqueda.persona-natural'),
      cancelar: this._translate.get('form.button.cancelar'),
      tramiteCanceladoPersonaJuridica: this._translate.get('components.app-resultados-busqueda.tramite-cancelado-persona-juridica'),
      inicioSesionCancelado: this._translate.get('components.app-resultados-busqueda.inicio-sesion-cancelado'),
      noHayRegistros: this._translate.get('components.app-resultados-busqueda.no-hay-datos'),
      noHayRegistrosDetalle: this._translate.get('components.app-resultados-busqueda.no-hay-datos-detalle'),
      tramiteInactivo: this._translate.get('msg.tramiteInactivo'),
      firmaElectronicaNoHabilitada: this._translate.get('msg.firmaElectronicaNoHabilitada'),
      yaExisteUnTramiteActivo: this._translate.get('msg.yaExiteUnTramiteActivo'),

    }));
  }

  unsubscribe() {
    if (this._loginSubscription) {
      this._loginSubscription.unsubscribe();
    }
    if (this._menuCloseSubscription) {
      this._menuCloseSubscription.unsubscribe();
    }
  }

  getTramitesBusqueda(search: string, dependencias?: number[]) {
    this.isLoading = true;
    const params: Omit<Required<PaginationParams>, 'sort'> = {
      page: this.page,
      size: this.rows
    }
    this._tt.getTramitesBusqueda(search, params, dependencias).subscribe({
      next: (td: Page<IGetTramitesBusqueda>) => {
        this.results = td.content;
        this.totalRecords.set(td.totalElements);
        if (td.first) this.first = 0;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    });
  }

  private tramiteConfig(result: IGetTramitesBusqueda) {
    let requierePersonaJuridica: boolean = false;
    let requierePersonaNatural: boolean = false;

    result.dirigidoTramite.forEach((dt: string) => {
      if (dt) {
        if (dt === "JURIDICA") {
          requierePersonaJuridica = true;
        } else if (dt === "NATURAL") {
          requierePersonaNatural = true;
        }
      }
    });
    const customComponentId = {id: result.customComponentId, version: result.customComponentVersion} as IIdCompuestoVersion;

    if (requierePersonaJuridica) {
      let text = this._translations.necesitaPersonaJuridica;
      if (requierePersonaNatural) {
        text = this._translations.necesitaPersonaJuridicaOpcional;
      }

      this.alertService.show({
        closable:true,
        data :{
          text: text,
          icon: AlertIcon.QUESTION,
          showAccept: true,
          textAccept: this._translations.personaJuridica,
          showCancel: true,
          textCancel: requierePersonaNatural ? this._translations.personaNatural :  this._translations.cancelar
        }
       }).subscribe((obj:ResponseAlert) => {
        if (obj.accept) {
          this._menuCloseSubscription = this._ams.closeSource$.subscribe(empresaId => {
            this.unsubscribe();
            this.validarTramiteActivo({dependenciaId: result.dependenciaId, tramiteId: result.id,
              customComponent:customComponentId,
              empresaId: empresaId});
          });
          this._ams.onOpenTab(3);
        } else if (obj.cancel) {
          if(requierePersonaNatural){
            this.validarTramiteActivo({dependenciaId: result.dependenciaId,
              customComponent:customComponentId,
              tramiteId: result.id});
          }else{
            this._ms.add({ severity: 'warn', summary: this._translations.warnSummary,
              detail: this._translations.tramiteCanceladoPersonaJuridica });
          }
        }
      });
    } else {
      this.validarTramiteActivo({dependenciaId:result.dependenciaId, tramiteId: result.id,
        customComponent: customComponentId,
      });
    }
  }

  private validarTramiteActivo(props:IValidarTramiteActivo){
    this._trs.tieneTramiteActivo(props.tramiteId).subscribe({
      next: (tieneTramiteActivo:boolean) => {
        if(tieneTramiteActivo){
          this._ms.add({
            severity: 'warn', summary: this._translations.warnSummary,
            detail: this._translations.yaExisteUnTramiteActivo
          });
           return;
        }
        if(props.empresaId){
          this._router.navigate(['/tramites/crear-tramite', props.dependenciaId, props.tramiteId,props.empresaId],
            {
              state: {data: props.customComponent }
            });
        }else{
          this._router.navigate(['/tramites/crear-tramite', props.dependenciaId, props.tramiteId],
            {
              state: {data: props.customComponent }
            });
        }
      }
    });
  }

  onIniciarTramite(result: IGetTramitesBusqueda) {
    if(result.requierePago && !result.costoVigente){
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.tramiteInactivo });
      return;
    }
    if (this._ls.isLoggedIn) {
      this.tramiteConfig(result);
      return;
    }

    this._loginSubscription = this._as.loginSource$.subscribe(key => {
      this.unsubscribe();
      if(this._ls.isFirmaElectronicaExpired){
        this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.firmaElectronicaNoHabilitada });
        return;
      }
      this.tramiteConfig(result);
    });

    this._menuCloseSubscription = this._ams.closeSource$.subscribe(key => {
      this.unsubscribe();
      if(this._ls.isFirmaElectronicaExpired){
        this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.firmaElectronicaNoHabilitada });
        return;
      }
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.inicioSesionCancelado });
    });

    this._ams.onMenuOpen();
  }

  get dependencias(){
    return this.dependencia?.map(f=> f.descripcion)?.join(", ") || 'Todas las dependencias';
  }

  onPageHandler(event: DataViewPageEvent) {
    this.first = event.first;
    this.page = event.first / event.rows;
    this.getTramitesBusqueda(this.text || ' ', this.dependencia?.map(f => f.id));
  }
}
